module.exports = __webpack_public_path__ + "static/img/shopee.a8d09c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/payment/shopee.png
// module id = h852
// module chunks = 0